// Note: borrowed some stuff from here: https://www.npmjs.com/package/angular-three-state-checkbox
// Could not use his component because it did not support ngTrueValue and ngFalseValue.
(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3TriCheckbox', {
            templateUrl: 'app/shared/generic/tri-checkbox.component.html',
            controller: TriCheckboxComponent,
            require: { ngModel: 'ngModel' }
        });

    var isDefined = angular.isDefined,
        isUndefined = angular.isUndefined;

    TriCheckboxComponent.$inject = ['$element', '$scope', '$attrs', '$parse', '$timeout'];
    function TriCheckboxComponent($element, $scope, $attrs, $parse, $timeout) {
        var ctrl = this, ngModel, checkbox,
            states = [true, false, null],
            trueValue = parseConstantExpr($parse, $scope, 'sc3TrueValue', $attrs.sc3TrueValue, true),
            falseValue = parseConstantExpr($parse, $scope, 'sc3FalseValue', $attrs.sc3FalseValue, false),
            nullValue = parseConstantExpr($parse, $scope, 'sc3NullValue', $attrs.sc3NullValue, null);

        ctrl.$onInit = init;
        ctrl.click = click;

        function init() {
            checkbox = $element.find('input');
            ngModel = ctrl.ngModel;
            ngModel.$render = render;
            ngModel.$formatters.push(format);
            ngModel.$parsers.push(parse);
            initEvents();
        }
        function initEvents() {
            var isFocused, isMouseDown;

            $element.on('focusin', focusin);
            $element.on('focusout', focusout);
            $element.on('mousedown', function mousedown() { isMouseDown = true; });
            $element.on('keydown', function keydown() { $element.addClass('focus'); });

            function focusin() {
                if (!isFocused) {
                    isFocused = true;
                    if (!isMouseDown)
                        $element.addClass('focus');
                }
                isMouseDown = false;
            }

            function focusout(e) {
                isFocused = e.target.contains(e.relatedTarget);
                isMouseDown = false;
                if (!isFocused) $element.removeClass('focus')
            }
            
        }

        function click(e) {
            e.preventDefault();
            ngModel.$setViewValue(ngModel.$viewValue === true ? false : ngModel.$viewValue === false ? null : true);
            $timeout(ngModel.$render.bind(ngModel), 0, false)
        }

        function render() {
            var box = checkbox[0];
            box.checked = ngModel.$viewValue === true;
            box.indeterminate = ngModel.$viewValue === null;
            $element.removeClass('checked unchecked clear');
            $element.addClass(box.indeterminate ? 'clear' : box.checked ? 'checked' : 'unchecked');
        }

        function format(value) {
            return value === trueValue ? true : value === falseValue ? false : null;
        }

        function parse(value) {
            return value === true ? trueValue : value === false ? falseValue : nullValue;
        }

    }

    function parseConstantExpr($parse, context, name, expression, fallback) {
        var parseFn;
        if (isDefined(expression)) {
            parseFn = $parse(expression);
            if (!parseFn.constant) {
                throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                    '`{1}`.', name, expression);
            }
            return parseFn(context);
        }
        return fallback;
    }
})();